// WHAT WE ARE OWED — the one figure above everything, the server's own `outstanding`.
// Nothing is summed here. What is late, and what is ours to do, are stated once each, in
// the heads of their own columns below; a tile row repeating them was the same
// information twice.
import he from '../../i18n/he';
import Money from '../../components/Money';

const mp = he.moneyScreen;

export default function Headline({ totals }) {
  return (
    <div className="mp-owed">
      <span className="mp-owed-label">{mp.owed}</span>
      <Money className="mp-owed-value" value={totals.outstanding} />
    </div>
  );
}
